import type { Gender, ProgramKind, Role } from "@mubin/contracts";

export const roleLabel: Record<Role, string> = {
  platform_admin: "تشغيل المنصة",
  org_admin: "إدارة الجمعية",
  branch_manager: "مدير المجمع",
  supervisor: "مشرف",
  teacher: "معلم",
  student: "طالب",
};

/** Roles that use the web portal. Teachers and students use the mobile app. */
export const PORTAL_ROLES: Role[] = ["platform_admin", "org_admin", "branch_manager", "supervisor"];

export const genderLabel: Record<Gender, string> = { male: "ذكور", female: "إناث" };
export const personGenderLabel: Record<Gender, string> = { male: "ذكر", female: "أنثى" };

export const programKindLabel: Record<ProgramKind, string> = {
  memorization: "الحفظ الجديد",
  review: "المراجعة والتثبيت",
  memorization_review: "الحفظ مع المراجعة",
  ijazah: "الإجازة",
  taahud: "التعاهد",
  other: "أخرى",
};

export const enrollmentStatusLabel = {
  active: "نشط",
  paused: "موقوف",
  transferred: "منقول",
  completed: "مكتمل",
  withdrawn: "منسحب",
} as const;

export const userStatusLabel = { active: "نشط", suspended: "موقوف", archived: "مؤرشف" } as const;

export const joinStatusLabel = { pending: "بانتظار القرار", accepted: "مقبول", rejected: "مرفوض" } as const;
export const deletionStatusLabel = {
  pending: "بانتظار القرار",
  completed: "عُطّل الحساب",
  rejected: "مرفوض",
} as const;

export const scopeLabel = {
  organization: "الجمعية",
  branch: "المجمع",
  circle: "الحلقة",
  self: "حساب شخصي",
} as const;
